/**
 * 笔记模块
 *
 * Markdown 笔记的发布与管理：合集/标签组织、图床插图、代码高亮渲染。
 * 发布（web 端）+ 查看（小程序端 pkgGrad/study-notes）。
 */

import type { WorkbenchModule } from '../types'

export const notesModule: WorkbenchModule = {
  meta: {
    name: 'notes',
    title: '笔记',
    description: 'Markdown 笔记：合集、标签、图床插图、代码高亮',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/notes',
      name: 'notes',
      component: () => import('./views/NoteListView.vue'),
      meta: { title: '笔记' }
    },
    {
      path: '/notes/collections',
      name: 'notes-collections',
      component: () => import('./views/NoteCollectionView.vue'),
      meta: { title: '合集管理' }
    },
    {
      // 编辑器：/notes/editor（新建）与 /notes/editor/:id（编辑）复用同一视图
      path: '/notes/editor/:id?',
      name: 'notes-editor',
      component: () => import('./views/NoteEditorView.vue'),
      meta: { title: '编辑笔记' }
    },
    {
      path: '/notes/:id',
      name: 'notes-detail',
      component: () => import('./views/NoteDetailView.vue'),
      meta: { title: '笔记详情' }
    }
  ],
  menuItem: {
    id: 'notes',
    label: '笔记',
    path: '/notes',
    icon: 'sticky-note',
    order: 31
  }
}
